import { usePaginatedSearch } from '../usePaginatedSearch';
import { getCreatorApplications } from '@/services/api/requests/creator-applications';
import queryKeys from '@/constants/queryKeys';
import { TSortingDirection } from '@/types';
import {
  TCreatorApplicantType,
  TCreatorApplicationListItem,
  TCreatorApplicationStatus,
} from '@/types/CreatorApplication.types';

const useCreatorApplications = ({
  filterText,
  status,
  applicantType,
  sortBy,
  sortDir,
  pageSize,
}: {
  filterText: string;
  status: TCreatorApplicationStatus;
  applicantType?: TCreatorApplicantType;
  sortBy: string;
  sortDir: TSortingDirection;
  pageSize: number;
}) => {
  return usePaginatedSearch<TCreatorApplicationListItem[], string, string>({
    query: (page, _searchFilterType, searchFilterText, sortingColumn, sortingDirection, pageSize) =>
      getCreatorApplications(
        page,
        searchFilterText,
        status,
        applicantType,
        sortingColumn && sortingDirection ? `${sortingColumn}:${sortingDirection}` : undefined,
        pageSize,
      ),
    queryKey: [queryKeys.creatorApplications.all, status, applicantType ?? 'all'],
    searchFilterType: applicantType ?? 'all',
    searchFilterText: filterText,
    sortingColumn: sortBy,
    sortingDirection: sortDir,
    pageSize,
  });
};

export default useCreatorApplications;
